/* eslint-disable import/order */
import { MenuIdSettings } from '@jira/navigation-apps__constants/src/MenuIdSettings.tsx';
import { SidebarIdGlobalProjectsSettings } from '@jira/navigation-apps__constants/src/SidebarIdGlobalProjectsSettings.tsx';
import { LazyAtlassianNavigation } from '@jira/navigation-apps__atlassian-navigation/src/async.tsx';
import { globalSettingsLayout } from '@jira/platform__layouts-global-settings-layout/src/index.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import { navigationSidebarGlobalResource } from '@jira/router-resources__navigation-sidebar-global/src/navigationSidebarGlobalResource.tsx';
import { getNavigationResources } from '@jira/router-resources__navigation/src/getNavigationResources.tsx';
import { archivedProjectsDirectoryRoute } from '@jira/router-routes__archived-projects-directory-routes/src/archivedProjectsDirectoryRoute.tsx';
import ArchivedProjectsDirectory, {
	LazyArchivedProjectsAdmin,
} from './ui/spa/admin-pages/archived-projects/index.tsx';
import type { Route } from '@atlassian/react-resource-router';

export const archivedProjectsDirectoryRouteEntry: Route = createEntry(
	archivedProjectsDirectoryRoute,
	() => ({
		group: 'global-settings',
		// eslint-disable-next-line no-restricted-syntax
		component: ArchivedProjectsDirectory,
		layout: globalSettingsLayout,

		navigation: {
			sidebarId: SidebarIdGlobalProjectsSettings,
			menuId: MenuIdSettings,
		},

		resources: [...getNavigationResources(), navigationSidebarGlobalResource],
		forPaint: [LazyAtlassianNavigation, LazyArchivedProjectsAdmin],
		ufoName: 'admin.archived-projects',

		bifrost: {
			bifrostGroup: 'shell-only',
		},
	}),
);
